export default "__VITE_ASSET__PTia20CW__"